import { http } from '../utils/http'

const searchAction = (params) => {
  const url = `/open/api/v1/air-flow/view/streaming/status`
  return http.post(url, params)
};
const restartAction = (params) => {
  const url = `/open/api/v1/air-flow/restart?dagName=${params}`
  return http.post(url, {})
};
export default {
  searchAction,
  restartAction,
}
